<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Electronic Payments") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                    ✖
                  </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                    ✖
                  </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getElectronicPayments('N', 'N')"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="electronicPaymentsRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>

            <a
              target="_blank"
              @click="getElectronicPayments('Y', 'N')"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="getElectronicPayments('N', 'Y')"
              title="Download as PDF"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>

      <div
        style="overflow-x:scroll;width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Credit Card Number</th>
            <th>Customer Name</th>
            <th>Expiry Date</th>
            <th>Amount</th>
            <th>User</th>
            <th>Workstation</th>
            <th colspan="3">Transaction</th>
            <th>Workstation Collected</th>
            <th>Date Collected</th>
            <th>Bank Authorization Code</th>
          </thead>
          <thead class="bg-lightgrey font-weight-bold">
            <th colspan="6"></th>
            <th>Date</th>
            <th>Time</th>
            <th>Number</th>
            <th colspan="3"></th>
          </thead>
          <tbody v-if="electronicPaymentsRecords.length > 0">
            <template
              v-for="(cardTypeObj, cardTypeIndex) in electronicPaymentsRecords"
            >
              <tr
                :key="cardTypeIndex"
                class="font-weight-bold electronic_payments_blue"
              >
                <td class="text-left" colspan="12">{{
                  cardTypeObj.cardType
                }}</td>
              </tr>
              <tr
                v-for="(cardObj, cardObjIndex) in cardTypeObj.cardData"
                :key="cardTypeIndex + 'cardData' + cardObjIndex"
              >
                <td class="text-left">{{ cardObj.card_number }}</td>
                <td class="text-left">{{ cardObj.customer_name }}</td>
                <td class="text-left">-</td>
                <td class="text-right">{{ currFormat(cardObj.amount) }}</td>
                <td class="text-left">{{ cardObj.username }}</td>
                <td class="text-left">{{ cardObj.hardware_name || "-" }}</td>
                <td class="text-left">{{ cardObj.transaction_date }}</td>
                <td class="text-left">{{ cardObj.transaction_time }}</td>
                <td class="text-left">{{ cardObj.sb_booking_code }}</td>
                <td class="text-left">-</td>
                <td class="text-left"
                  >{{ cardObj.transaction_date }}
                  {{ cardObj.transaction_time }}</td
                >
                <td class="text-left">{{ cardObj.authorization_id }}</td>
              </tr>
              <tr
                class="bg-lightgrey"
                :key="cardTypeIndex + 'cardData' + 'cardSummary'"
              >
                <td class="text-left" colspan="3"
                  >Total for
                  {{ paymentSummaryData[cardTypeIndex].card_type }}</td
                >
                <td class="text-right">{{
                  currFormat(paymentSummaryData[cardTypeIndex].total_amount)
                }}</td>
                <td class="text-left" colspan="8"></td>
              </tr>
            </template>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="15">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="section-title my-2">
          {{ $t("Overall Summary") }}
        </div>
        <table class="swc-report-table mt-1" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Card Type</th>
            <th>Charges</th>
            <th>Refunds</th>
            <th>Balance</th>
            <th>Count</th>
          </thead>
          <tbody v-if="paymentSummaryData.length">
            <tr
              v-for="(paymentObj, paymentObjIndex) in paymentSummaryData"
              :key="paymentObjIndex"
            >
              <td class="text-left">{{ paymentObj.card_type }}</td>
              <td class="text-right">{{
                currFormat(paymentObj.total_amount)
              }}</td>
              <td class="text-right">0</td>
              <td class="text-right">{{
                currFormat(paymentObj.total_amount)
              }}</td>
              <td class="text-right">{{ paymentObj.total_counts }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      electronicPaymentsRecords: [],
      paymentSummaryData: [],
      excelFilePath: "",
      grandTotal: {},
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
    onChangeDate: function(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {
        sheet: `RawMaterialSupplierWise`,
      });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
            wb,
            fn ||
              `RawMaterialSupplierWiseCost-${
                this.dropDown.selectedCinemaName
              }.${type || "xlsx"}`
          );
    },
    getCinemaList: function() {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
           // data.Records.unshift({ cine_id: 0, cine_name: "All Cinemas" });
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function(event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getElectronicPayments(isExcel = "N", isPdf = "N") {
      this.transactionSummaryRecords = [];

if (!this.dropDown.selectedCinemaId) {
             return this.$toasted.show("Select Cinema");
           }

      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isExcel,
        isPdf,
      };
      ReportsService.GetElectronicPayments(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.electronicPaymentsRecords = [...data.Records];
            this.paymentSummaryData = [...data.paymentRecordsSummary];
            // this.grandTotal = data.grandTotal;
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
.electronic_payments_blue {
  background-color: #c5d6f0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/electronicPaymentsReport.vue